var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV3CloseModalHoverIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 3.94L12.3933 3L8.66667 6.72667L4.94 3L4 3.94L7.72667 7.66667L4 11.3933L4.94 12.3333L8.66667 8.60667L12.3933 12.3333L13.3333 11.3933L9.60667 7.66667L13.3333 3.94Z",
    fill: "#3537E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV3CloseModalHoverIco);
export default __webpack_public_path__ + "static/media/v3-close-modal-hover-ico.4260bd6639d46c0b73c56a750530feb3.svg";
export { ForwardRef as ReactComponent };